import React from 'react';
import { Routes, Route, NavLink } from 'react-router-dom';
import { PageContentWrapper, PageHeader } from '../main/LayoutStyles';
import styled from 'styled-components';
import { Calendar, CheckSquare } from 'lucide-react';

import PsychologistAvailability from '../appointment/PsychologistAvailability';
import PsychologistAppointments from '../appointment/PsychologistAppointments';

const SpecialistPanelLayout = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const PanelNav = styled.nav`
    display: flex;
    gap: 1rem;
    border-bottom: 1px solid ${({ theme }) => theme.colors.borderColor};
    padding-bottom: 1rem;
`;

const PanelNavLink = styled(NavLink)`
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.6rem 1.2rem;
    border-radius: ${({ theme }) => theme.borderRadius};
    font-weight: 600;
    color: ${({ theme }) => theme.colors.textMedium};
    text-decoration: none;
    transition: all 0.2s ease-in-out;

    &:hover {
        color: ${({ theme }) => theme.colors.primaryDark};
        background-color: ${({ theme }) => theme.colors.neutralLight};
    }

    &.active {
        background-color: ${({ theme }) => theme.colors.primary};
        color: white;
    }
`;

const SpecialistPanel = () => {
    return (
        <PageContentWrapper className="custom-scrollbar">
            <SpecialistPanelLayout>
                <PageHeader>Panel Specjalisty</PageHeader>
                <PanelNav>
                    <PanelNavLink to="/app/specialist-panel/availability">
                        <Calendar size={18} />
                        Moja Dostępność
                    </PanelNavLink>
                    <PanelNavLink to="/app/specialist-panel/appointments">
                        <CheckSquare size={18} />
                        Zarządzaj Wizytami
                    </PanelNavLink>
                </PanelNav>

                <div>
                    <Routes>
                        <Route path="availability" element={<PsychologistAvailability />} />
                        <Route path="appointments" element={<PsychologistAppointments />} />
                        <Route index element={<div>Wybierz sekcję, aby rozpocząć zarządzanie.</div>} />
                    </Routes>
                </div>
            </SpecialistPanelLayout>
        </PageContentWrapper>
    );
};

export default SpecialistPanel;